import { api } from "@/lib/api";

/** Verificación contra el catálogo de Ventas (el aviso anti-goles).
 * Tipos locales de este flujo: solo los usa Ventas. (Cuando se escribió, lib/api
 * era un solo archivo pasado de líneas; desde 2026-10-13 es `lib/api/` por tema.) */

export type VentaMini = {
  fecha_cierre: string | null;
  empresa: string | null;
  cotizacion: string | null;
  es_garantia: boolean;
};

export type VerificacionVenta = {
  valor: string;
  vendido: boolean;
  ventas: VentaMini[]; // más recientes primero, máximo 3
};

export function verificarVentas(valores: string[]): Promise<VerificacionVenta[]> {
  return api.post<VerificacionVenta[]>("/api/ventas/verificar", { valores });
}

const fmtFecha = new Intl.DateTimeFormat("es-MX", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

/** "Vendido a GLOBAL TRACK el 29 jul 2026 · cot. 13371 · ya tuvo garantía" */
export function resumenVenta(check: VerificacionVenta): string {
  const v = check.ventas[0];
  if (!v) return "No aparece en nuestras ventas";
  const partes = [
    `Vendido a ${v.empresa || "(sin empresa)"}`,
    v.fecha_cierre ? `el ${fmtFecha.format(new Date(`${v.fecha_cierre}T00:00:00`))}` : "",
    v.cotizacion ? `· cot. ${v.cotizacion}` : "",
  ];
  if (check.ventas.some((x) => x.es_garantia)) partes.push("· ya tuvo garantía");
  return partes.filter(Boolean).join(" ");
}
